// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body::-webkit-scrollbar {
  display: none;
}

.drawerCloseIcon {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}

.drawerCloseIcon ::selection {
  color: #7ed957;
}

.closePopCrossIcon {
  color: white !important;
}

@media (max-width: 576px) {
  .popUpInputContainer {
    padding: 5rem 0.5rem;
    box-shadow: 0px 0px 10px -5px #000000;
    border-radius: 5px;
  }
}

.popUpInput {
  padding: 30px 5px !important;
  border-radius: 6px !important;
  width: 100%;
  margin-bottom: 20px !important;
}

.popUpVerifyBtn {
  margin-left: 8%;
  font-size: medium;

  border: none !important;
  color: #7ed957;
  cursor: pointer;
}

.popUpVerifyBtn1 {
  margin-left: 8%;
  font-size: medium;
  color: white;
  cursor: pointer;
}

.skipBtnContainer {
  display: flex !important;
  width: 100% !important;
  margin-top: 3vh !important;
  flex-direction: column;
  gap: 1rem;
}

.btn-container {
  display: flex;
  gap: 1rem;
}

.btn-container > button {
  flex: 1;
}

.popUpHoldOrderBtn {
  width: 100%;
  height: 5vh;
  background-color: #e79837 !important;
  border-radius: 8px;
  color: white;
  border: none;
  font-weight: bold;
  cursor: pointer;
  letter-spacing: 1px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.2rem;
  min-height: 2.8rem;
}

.popUpAddBtn {
  width: 100%;
  height: 5vh;
  background-color: #2954a5 !important;
  border-radius: 8px;
  color: white;
  border: none;
  font-weight: bold;
  cursor: pointer;
  letter-spacing: 1px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.2rem;
  min-height: 2.8rem;
}

.popUpSkipBtn {
  font-weight: bold;
  cursor: pointer;
  letter-spacing: 1px;
  text-align: center;
  margin: 1rem 0;
  display: flex;
  justify-content: center;
}

.skip-btn {
  all: unset;
  outline: revert;
}

.holdOrderBtn1 {
  background-color: #e79837;
  color: white !important;
}

.addCustomerBtn {
  background-color: #2954a5 !important;
  color: white !important;
}

.skipNowbtn {
  cursor: pointer !important;
}

.all-products-container {
  /* background-color: #f7f7ff; */
  background-color: #f5f5f5;
  margin-top: 3.2rem !important;
  padding: 1rem;
  height: calc(100% - 3.2rem) !important;
}

@media (max-width: 576px) {
  .all-products-container {
    padding: 0.5rem;
  }
}

.dark .all-products-container {
  background-color: #2b2f42;
}

.leftContainer-all {
  overflow: scroll;
  position: relative;
  border: 0.5px solid #bcbcbc;
  border-radius: 2px;
  padding: 10px;
  background-color: #fff;
}

.addCustomericonsDiv {
  display: flex;
  align-content: center;
  color: white;
}

.subContainer {
  width: 100%;
}

.inputText {
  width: 100%;
  border-radius: 20px;
  border: 1px solid black;
  padding: 7px 0px;
  padding-left: 2vw;
  height: 5vh;
  margin-bottom: 1vh;
}

.categoryText {
  display: flex;
  justify-content: flex-start !important;
  font-size: 1rem;
  color: white;
  margin-top: 2vh !important;
  margin-bottom: 1vh;
}

.dark .categoryText {
  color: white;
}

.light .categoryText {
  color: black;
}

.customers {
  margin-top: 5vh;
  margin-bottom: 1vh;
  font-size: 1rem;
}

.dark .customers {
  color: white;
}

.light .customers {
  color: black;
}

.customerContainer {
  padding-left: 5px !important;
  display: flex;
  justify-content: flex-start;
  height: 16vh !important;
  overflow-x: auto !important;
}

@media (max-width: 576px) {
  .customerContainer {
    flex-direction: column !important;
  }
}

.light .customerContainer:focus {
  outline: none !important;
}

.dark .customerContainer:focus {
  outline: none !important;
}

.customerContainer::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.customerContainer::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  background-color: #f5f5f5;
}

.customerContainer::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #cbcbcb;
}

.customerDiv {
  border-radius: 10px;
  min-width: 20% !important;
  height: 13vh;
  display: flex;
  align-items: center !important;
  text-align: center !important;
  font-size: 13px;
  font-weight: 600;
  justify-content: center;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 0px 10px 0px !important;
  cursor: pointer;
  margin: 0.5rem 5% 0.5rem 0 !important;
  border: 1px solid rgb(255 255 255 / 10%);
  background-color: #e3e8ff;
  color: #2954a5;
}

@media (max-width: 576px) {
  .customerDiv {
    padding: 0.8rem 0;
  }
}

.dark .customerDiv {
  background-color: #353a50;
  color: white;
}

.light .customerDiv {
  background-color: white;
  color: black;
}

.light .customerDiv:focus {
  background-color: #e3e8ff !important;
  color: #2954a5 !important;
  border: solid 1px #2954a5 !important;
  opacity: 0.5;
  outline: none;
}

.dark .customerDiv:focus {
  background-color: #e3e8ff !important;
  color: #2954a5 !important;
  border: solid 1px #2954a5 !important;
  opacity: 0.5;
  outline: none;
}

.modal-input {
  width: 100%;
  border-radius: 6px;
  border: 1px solid black !important;
  outline: none;
  height: 2rem;
  padding: 10px;
}

.dark .modal-input {
  border: 1px solid white !important;
}

.rightContainer {
  display: flex;
  flex-direction: column !important;
  justify-content: space-between;
}

.qrScanner {
  width: 60% !important;
  height: 25vh !important;
}

.paymentBox {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
}

.hrLine {
  margin-top: 4vh;
}

.paymentmethod {
  font-size: 0.9rem;
  font-weight: bold;
}

.paymentIconsContainer {
  display: flex;
  gap: 0.3rem;
}

.offline-btn {
  padding: 10.5px;
  cursor: pointer;
  border-radius: 7px;
  border: 1px solid lightblue;
  display: flex;
  align-items: center;
  color: #2954a5;
  gap: 3px;
  margin-top: 15px;
  margin-left: 3px;
}

.whats-app-logo {
  color: #4cc85a !important;
  width: 20px !important;
  height: 20px !important;
}

.whats-app-logo-I {
  color: gray !important;
  width: 20px !important;
  height: 20px !important;
}

.openBtn {
  width: 100%;
  height: 5vh;
  background-color: #2954a5 !important;
  border-radius: 10px;
  color: white;
  margin-top: 2vh;
  border: none;
  font-weight: bold;
  cursor: pointer;
  box-shadow: #2954a5 0px 3px 5px -2px !important;
  letter-spacing: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.activePaymentIcon-splitI {
  padding: 4px;
  border-radius: 7px;
  background-color: #50c878 !important;
  color: #fff !important;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 18px 50px -10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 3px;
  border: 1px solid lightblue;
  margin-left: 3px;
  margin-top: 15px;
  font-size: 0.7rem;
}

.cart-container {
  height: 100vh;
  height: 100dvh;
}

.holdOrderBtn {
  width: 45%;
  height: 5vh;
  background-color: #e79837 !important;
  border-radius: 20px;
  color: white;
  margin-top: 2vh;
  border: none;
  cursor: pointer;
  margin-right: 10%;
}

.CreditCardIcon {
  display: flex;
  justify-content: space-between;
}

.systemHealthText {
  font-size: 1rem;
  color: white;
  margin-bottom: 0px;
}

.systemHealthIcons {
  color: green !important;
  height: 10vh !important;
  width: 8% !important;
  margin-right: 10px;
}

.addCustomericonsDiv {
  font-size: 1rem;
  margin-bottom: 2vh;
  text-align: center;
}

.fixedPosition {
  margin-top: 10vh !important;
}

.adjustOrderBox {
  display: flex;
}

.adjustOrderBox p {
  padding: 2px;

  text-align: center;
  align-content: center !important;
  align-items: center !important;
}

.dark .systemHealthText {
  color: white;
}

.light .systemHealthText {
  color: black !important;
}

@media (max-width: 768px) {
  .shortcut-wrapper-box-I {
    display: none !important;
  }

  .fixedPosition {
    display: none;
  }
}

@media screen and (min-width: 900px) {
  .fixedPosition1 {
    display: none !important;
  }
}

.fixedPosition1 {
  margin-top: 5vh !important;
}

.systemHealthText1 {
  font-size: 1rem;
  margin-bottom: 0px;
}

.dark .systemHealthText1 {
  color: white;
}

.light .systemHealthText1 {
  color: black;
}

.systemHealthIcons1 {
  color: green !important;
  height: 5vh !important;
  width: 8% !important;
  margin-right: 10px;
}

.catgeory-image-wrappper {
  width: 100%;
  height: 95%;
  object-fit: cover;
  border-radius: 7px;
}

.show-loyaty-wrapper-info {
  box-shadow: 0 1.5rem 4rem rgba(#000, 0.9);
  border-radius: 7px;
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 0;
  max-width: 50%;
  max-height: 100%;
  -webkit-transform: translate(50%, -50%);
  -moz-transform: translate(50%, -50%);
  -ms-transform: translate(50%, -50%);
  transform: translate(50%, -50%);
  width: 50%;
  display: block;
  border-radius: 10px;
  padding: 1.5rem;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  background-color: #fff !important;
  color: #353a50 !important;
}

@media (max-width: 576px) {
  .show-loyaty-wrapper-info {
    top: 0;
    left: 0;
    max-width: 100%;
    height: 100%;
    transform: none;
    display: block;
    border-radius: 10px;
    padding: 1.5rem;
    flex-direction: column;
    background-color: #fff !important;
    color: #353a50 !important;
  }
}

.show-loyaty-wrapper-info-I {
  width: 700px;
  padding: 5.5rem;
  background-color: #fff;
  box-shadow: 0 1.5rem 4rem rgba(#000, 0.9);
  border-radius: 7px;
  height: 500px;
  position: relative;
  overflow: hidden;
  margin-top: -8rem;
  transform: translateX(-10rem);
}

.dark .show-loyaty-wrapper-info-I {
  background-color: var(--dark-background) !important;
}

@media (max-width: 576px) {
  .show-loyaty-wrapper-info {
    width: 100%;
  }
}

.Loyalty-text-down {
  margin: 20px 0;
}

.dark .show-loyaty-wrapper-info {
  background-color: var(--dark-background) !important;
  color: #fff;
}

.show-loyaty-wrapper-info--text {
  text-align: center;
  line-height: 2;
  margin-bottom: 10px;
}

.available-wrapper-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
}

.available-wrapper-box-I {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  margin-top: 15px;
}

.refresh-wrapper-box {
  display: flex;
  align-items: center;
  float: right;
  justify-content: center;
  color: #5271ff !important;
  cursor: pointer;
  margin-bottom: 5px;
  transform: translateY(-10px) translateX(13px);
}

.redeem-wrapper-btn {
  border: none;
  width: 99%;
  background-color: #2954a5;
  color: #fff;
  font-weight: 600;
  margin-top: 15px;
  border-radius: 5px;
  padding: 8px;
  text-transform: uppercase;
}

.redeem-wrapper-btn-light {
  border: none;
  width: 99%;
  background-color: #89b0ee;
  color: #fff;
  font-weight: 600;
  margin-top: 15px;
  border-radius: 5px;
  padding: 8px;
  text-transform: uppercase;
}

.redeem-para-wrapper-box {
  margin-top: 1rem;
  font-size: 0.8em;
}

.show-loyalty-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.redeem-para-down-red {
  color: red;
  font-weight: 600;
}

.redeem-para-down-green {
  color: green;
  font-weight: 600;
}

.redeem-wrapper-btn-remove-red {
  border: none;
  width: 99%;
  background-color: red;
  color: #fff;
  font-weight: 600;
  margin-top: 15px;
  border-radius: 5px;
  padding: 8px;
  text-transform: uppercase;
}

.all-product-wrapper-shortcuts-box {
  border: 1px solid red;
  height: 40px;
  margin-top: 15px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.search-results-text {
  padding: 10px 0px 10px 0px !important;
}

.searchLoader {
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: center;
}

/* For Catefory Products view */
.particularCategoryEachItemGridContainerCFS {
  overflow-y: scroll !important;
  display: grid;
  align-content: flex-start;
  flex: 1;
  flex-wrap: wrap !important;
  padding-top: 10px !important;
  border-radius: 4px;
}

.particularCategoryEachItemCFS {
  width: auto !important;
  border-radius: 20px !important;
  margin-bottom: 1vh !important;
  border: 1.5px solid var(--surface-g1);
  min-width: 10rem;
  background-color: #fff;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.particularCategoryEachItemCFS.dark {
  border: none !important;
}

.particularCategoryContainer::-webkit-scrollbar {
  display: none;
}

.particularCategoryEachItemImgContainerCFS {
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 10px;
  position: relative;
}

.particularCategoryEachItemImgCFS {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 5px !important;
}

.foodTypeIcon {
  height: 14px;
  width: 14px;
  position: absolute;
  left: 88%;
  bottom: 82%;
}

.particularElementNameCFS {
  font-size: 0.75rem;
  text-transform: uppercase !important;
  width: 100%;
  font-weight: 700;
  word-wrap: break-word;
  white-space: normal;
}
/* Til Here */

.navigate-wrapper-product-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  cursor: pointer;
}

.dark .navigate-wrapper-product-box {
  background-color: #353a50 !important;
}

.offer-details-highlight {
  color: #0562fb !important;
  font-size: 0.7rem;
  font-weight: bold;
}

.light .offer-details-highlight {
  color: white !important;
}

.dark .offer-details-highlight {
  color: white !important;
}

.strike-off-mrp {
  font-size: 1rem !important;
}

.sticky-box-mrp {
  position: sticky;
  top: 0;
  background-color: #fff !important;
  padding: 10px 10px 20px 10px !important;
  text-align: center;
  z-index: 99;
}

.dark .sticky-box-mrp {
  position: sticky;
  top: 0;
  background-color: rgb(53, 58, 80) !important;
  padding: 10px 10px 20px 10px !important;
  text-align: center;
}

.text-mrp-heading {
  text-transform: capitalize;
  font-size: 18px !important;
}

.toggle-option-wrapper-modal {
  padding: 2rem;
  line-height: 2;
  width: 100%;
}

.toggle-option-wrapper-modal:focus {
  outline: none;
}

.configure-header-txt {
  margin-left: 0.2rem;
  font-size: 1.4rem;
  font-weight: 600;
  color: #5271ff;
  line-height: 3;
}

.label-toggle-txt {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  font-size: 1em;
  font-weight: 500;
  letter-spacing: 0.1rem;
}

.toggle-wrapper-btn-modal {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
}

.save-toggle-wrapper-btn {
  padding: 8px;
  background-color: #0562fb;
  color: #fff;
  font-size: 0.8rem;
  width: 120px;
  border: none;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 2rem !important;
}

.save-toggle-wrapper-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.all-products-icon-cont {
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/all-products.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,oBAAoB;IACpB,qCAAqC;IACrC,kBAAkB;EACpB;AACF;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;;EAEjB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gEAAgE;EAChE,eAAe;EACf,qCAAqC;EACrC,wCAAwC;EACxC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;EACpC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;EACpC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,kDAAkD;EAClD,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;;EAEZ,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,OAAO;EACP,cAAc;EACd,gBAAgB;EAChB,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,+BAA+B;EAC/B,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE;IACE,MAAM;IACN,OAAO;IACP,eAAe;IACf,YAAY;IACZ,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mDAAmD;EACnD,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,OAAO;EACP,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;EAC7B,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA,aAAa;;AAEb;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,4CAA4C;EAC5C,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,SAAS;AACX","sourcesContent":["body::-webkit-scrollbar {\n  display: none;\n}\n\n.drawerCloseIcon {\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.drawerCloseIcon ::selection {\n  color: #7ed957;\n}\n\n.closePopCrossIcon {\n  color: white !important;\n}\n\n@media (max-width: 576px) {\n  .popUpInputContainer {\n    padding: 5rem 0.5rem;\n    box-shadow: 0px 0px 10px -5px #000000;\n    border-radius: 5px;\n  }\n}\n\n.popUpInput {\n  padding: 30px 5px !important;\n  border-radius: 6px !important;\n  width: 100%;\n  margin-bottom: 20px !important;\n}\n\n.popUpVerifyBtn {\n  margin-left: 8%;\n  font-size: medium;\n\n  border: none !important;\n  color: #7ed957;\n  cursor: pointer;\n}\n\n.popUpVerifyBtn1 {\n  margin-left: 8%;\n  font-size: medium;\n  color: white;\n  cursor: pointer;\n}\n\n.skipBtnContainer {\n  display: flex !important;\n  width: 100% !important;\n  margin-top: 3vh !important;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.btn-container {\n  display: flex;\n  gap: 1rem;\n}\n\n.btn-container > button {\n  flex: 1;\n}\n\n.popUpHoldOrderBtn {\n  width: 100%;\n  height: 5vh;\n  background-color: #e79837 !important;\n  border-radius: 8px;\n  color: white;\n  border: none;\n  font-weight: bold;\n  cursor: pointer;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.2rem;\n  min-height: 2.8rem;\n}\n\n.popUpAddBtn {\n  width: 100%;\n  height: 5vh;\n  background-color: #2954a5 !important;\n  border-radius: 8px;\n  color: white;\n  border: none;\n  font-weight: bold;\n  cursor: pointer;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.2rem;\n  min-height: 2.8rem;\n}\n\n.popUpSkipBtn {\n  font-weight: bold;\n  cursor: pointer;\n  letter-spacing: 1px;\n  text-align: center;\n  margin: 1rem 0;\n  display: flex;\n  justify-content: center;\n}\n\n.skip-btn {\n  all: unset;\n  outline: revert;\n}\n\n.holdOrderBtn1 {\n  background-color: #e79837;\n  color: white !important;\n}\n\n.addCustomerBtn {\n  background-color: #2954a5 !important;\n  color: white !important;\n}\n\n.skipNowbtn {\n  cursor: pointer !important;\n}\n\n.all-products-container {\n  /* background-color: #f7f7ff; */\n  background-color: #f5f5f5;\n  margin-top: 3.2rem !important;\n  padding: 1rem;\n  height: calc(100% - 3.2rem) !important;\n}\n\n@media (max-width: 576px) {\n  .all-products-container {\n    padding: 0.5rem;\n  }\n}\n\n.dark .all-products-container {\n  background-color: #2b2f42;\n}\n\n.leftContainer-all {\n  overflow: scroll;\n  position: relative;\n  border: 0.5px solid #bcbcbc;\n  border-radius: 2px;\n  padding: 10px;\n  background-color: #fff;\n}\n\n.addCustomericonsDiv {\n  display: flex;\n  align-content: center;\n  color: white;\n}\n\n.subContainer {\n  width: 100%;\n}\n\n.inputText {\n  width: 100%;\n  border-radius: 20px;\n  border: 1px solid black;\n  padding: 7px 0px;\n  padding-left: 2vw;\n  height: 5vh;\n  margin-bottom: 1vh;\n}\n\n.categoryText {\n  display: flex;\n  justify-content: flex-start !important;\n  font-size: 1rem;\n  color: white;\n  margin-top: 2vh !important;\n  margin-bottom: 1vh;\n}\n\n.dark .categoryText {\n  color: white;\n}\n\n.light .categoryText {\n  color: black;\n}\n\n.customers {\n  margin-top: 5vh;\n  margin-bottom: 1vh;\n  font-size: 1rem;\n}\n\n.dark .customers {\n  color: white;\n}\n\n.light .customers {\n  color: black;\n}\n\n.customerContainer {\n  padding-left: 5px !important;\n  display: flex;\n  justify-content: flex-start;\n  height: 16vh !important;\n  overflow-x: auto !important;\n}\n\n@media (max-width: 576px) {\n  .customerContainer {\n    flex-direction: column !important;\n  }\n}\n\n.light .customerContainer:focus {\n  outline: none !important;\n}\n\n.dark .customerContainer:focus {\n  outline: none !important;\n}\n\n.customerContainer::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #f5f5f5;\n}\n\n.customerContainer::-webkit-scrollbar {\n  width: 3px;\n  height: 3px;\n  background-color: #f5f5f5;\n}\n\n.customerContainer::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #cbcbcb;\n}\n\n.customerDiv {\n  border-radius: 10px;\n  min-width: 20% !important;\n  height: 13vh;\n  display: flex;\n  align-items: center !important;\n  text-align: center !important;\n  font-size: 13px;\n  font-weight: 600;\n  justify-content: center;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 0px 10px 0px !important;\n  cursor: pointer;\n  margin: 0.5rem 5% 0.5rem 0 !important;\n  border: 1px solid rgb(255 255 255 / 10%);\n  background-color: #e3e8ff;\n  color: #2954a5;\n}\n\n@media (max-width: 576px) {\n  .customerDiv {\n    padding: 0.8rem 0;\n  }\n}\n\n.dark .customerDiv {\n  background-color: #353a50;\n  color: white;\n}\n\n.light .customerDiv {\n  background-color: white;\n  color: black;\n}\n\n.light .customerDiv:focus {\n  background-color: #e3e8ff !important;\n  color: #2954a5 !important;\n  border: solid 1px #2954a5 !important;\n  opacity: 0.5;\n  outline: none;\n}\n\n.dark .customerDiv:focus {\n  background-color: #e3e8ff !important;\n  color: #2954a5 !important;\n  border: solid 1px #2954a5 !important;\n  opacity: 0.5;\n  outline: none;\n}\n\n.modal-input {\n  width: 100%;\n  border-radius: 6px;\n  border: 1px solid black !important;\n  outline: none;\n  height: 2rem;\n  padding: 10px;\n}\n\n.dark .modal-input {\n  border: 1px solid white !important;\n}\n\n.rightContainer {\n  display: flex;\n  flex-direction: column !important;\n  justify-content: space-between;\n}\n\n.qrScanner {\n  width: 60% !important;\n  height: 25vh !important;\n}\n\n.paymentBox {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.9rem;\n}\n\n.hrLine {\n  margin-top: 4vh;\n}\n\n.paymentmethod {\n  font-size: 0.9rem;\n  font-weight: bold;\n}\n\n.paymentIconsContainer {\n  display: flex;\n  gap: 0.3rem;\n}\n\n.offline-btn {\n  padding: 10.5px;\n  cursor: pointer;\n  border-radius: 7px;\n  border: 1px solid lightblue;\n  display: flex;\n  align-items: center;\n  color: #2954a5;\n  gap: 3px;\n  margin-top: 15px;\n  margin-left: 3px;\n}\n\n.whats-app-logo {\n  color: #4cc85a !important;\n  width: 20px !important;\n  height: 20px !important;\n}\n\n.whats-app-logo-I {\n  color: gray !important;\n  width: 20px !important;\n  height: 20px !important;\n}\n\n.openBtn {\n  width: 100%;\n  height: 5vh;\n  background-color: #2954a5 !important;\n  border-radius: 10px;\n  color: white;\n  margin-top: 2vh;\n  border: none;\n  font-weight: bold;\n  cursor: pointer;\n  box-shadow: #2954a5 0px 3px 5px -2px !important;\n  letter-spacing: 1px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.activePaymentIcon-splitI {\n  padding: 4px;\n  border-radius: 7px;\n  background-color: #50c878 !important;\n  color: #fff !important;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 18px 50px -10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  border: 1px solid lightblue;\n  margin-left: 3px;\n  margin-top: 15px;\n  font-size: 0.7rem;\n}\n\n.cart-container {\n  height: 100vh;\n  height: 100dvh;\n}\n\n.holdOrderBtn {\n  width: 45%;\n  height: 5vh;\n  background-color: #e79837 !important;\n  border-radius: 20px;\n  color: white;\n  margin-top: 2vh;\n  border: none;\n  cursor: pointer;\n  margin-right: 10%;\n}\n\n.CreditCardIcon {\n  display: flex;\n  justify-content: space-between;\n}\n\n.systemHealthText {\n  font-size: 1rem;\n  color: white;\n  margin-bottom: 0px;\n}\n\n.systemHealthIcons {\n  color: green !important;\n  height: 10vh !important;\n  width: 8% !important;\n  margin-right: 10px;\n}\n\n.addCustomericonsDiv {\n  font-size: 1rem;\n  margin-bottom: 2vh;\n  text-align: center;\n}\n\n.fixedPosition {\n  margin-top: 10vh !important;\n}\n\n.adjustOrderBox {\n  display: flex;\n}\n\n.adjustOrderBox p {\n  padding: 2px;\n\n  text-align: center;\n  align-content: center !important;\n  align-items: center !important;\n}\n\n.dark .systemHealthText {\n  color: white;\n}\n\n.light .systemHealthText {\n  color: black !important;\n}\n\n@media (max-width: 768px) {\n  .shortcut-wrapper-box-I {\n    display: none !important;\n  }\n\n  .fixedPosition {\n    display: none;\n  }\n}\n\n@media screen and (min-width: 900px) {\n  .fixedPosition1 {\n    display: none !important;\n  }\n}\n\n.fixedPosition1 {\n  margin-top: 5vh !important;\n}\n\n.systemHealthText1 {\n  font-size: 1rem;\n  margin-bottom: 0px;\n}\n\n.dark .systemHealthText1 {\n  color: white;\n}\n\n.light .systemHealthText1 {\n  color: black;\n}\n\n.systemHealthIcons1 {\n  color: green !important;\n  height: 5vh !important;\n  width: 8% !important;\n  margin-right: 10px;\n}\n\n.catgeory-image-wrappper {\n  width: 100%;\n  height: 95%;\n  object-fit: cover;\n  border-radius: 7px;\n}\n\n.show-loyaty-wrapper-info {\n  box-shadow: 0 1.5rem 4rem rgba(#000, 0.9);\n  border-radius: 7px;\n  overflow: hidden;\n  position: fixed;\n  top: 50%;\n  left: 0;\n  max-width: 50%;\n  max-height: 100%;\n  -webkit-transform: translate(50%, -50%);\n  -moz-transform: translate(50%, -50%);\n  -ms-transform: translate(50%, -50%);\n  transform: translate(50%, -50%);\n  width: 50%;\n  display: block;\n  border-radius: 10px;\n  padding: 1.5rem;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  background-color: #fff !important;\n  color: #353a50 !important;\n}\n\n@media (max-width: 576px) {\n  .show-loyaty-wrapper-info {\n    top: 0;\n    left: 0;\n    max-width: 100%;\n    height: 100%;\n    transform: none;\n    display: block;\n    border-radius: 10px;\n    padding: 1.5rem;\n    flex-direction: column;\n    background-color: #fff !important;\n    color: #353a50 !important;\n  }\n}\n\n.show-loyaty-wrapper-info-I {\n  width: 700px;\n  padding: 5.5rem;\n  background-color: #fff;\n  box-shadow: 0 1.5rem 4rem rgba(#000, 0.9);\n  border-radius: 7px;\n  height: 500px;\n  position: relative;\n  overflow: hidden;\n  margin-top: -8rem;\n  transform: translateX(-10rem);\n}\n\n.dark .show-loyaty-wrapper-info-I {\n  background-color: var(--dark-background) !important;\n}\n\n@media (max-width: 576px) {\n  .show-loyaty-wrapper-info {\n    width: 100%;\n  }\n}\n\n.Loyalty-text-down {\n  margin: 20px 0;\n}\n\n.dark .show-loyaty-wrapper-info {\n  background-color: var(--dark-background) !important;\n  color: #fff;\n}\n\n.show-loyaty-wrapper-info--text {\n  text-align: center;\n  line-height: 2;\n  margin-bottom: 10px;\n}\n\n.available-wrapper-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 700;\n}\n\n.available-wrapper-box-I {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 700;\n  margin-top: 15px;\n}\n\n.refresh-wrapper-box {\n  display: flex;\n  align-items: center;\n  float: right;\n  justify-content: center;\n  color: #5271ff !important;\n  cursor: pointer;\n  margin-bottom: 5px;\n  transform: translateY(-10px) translateX(13px);\n}\n\n.redeem-wrapper-btn {\n  border: none;\n  width: 99%;\n  background-color: #2954a5;\n  color: #fff;\n  font-weight: 600;\n  margin-top: 15px;\n  border-radius: 5px;\n  padding: 8px;\n  text-transform: uppercase;\n}\n\n.redeem-wrapper-btn-light {\n  border: none;\n  width: 99%;\n  background-color: #89b0ee;\n  color: #fff;\n  font-weight: 600;\n  margin-top: 15px;\n  border-radius: 5px;\n  padding: 8px;\n  text-transform: uppercase;\n}\n\n.redeem-para-wrapper-box {\n  margin-top: 1rem;\n  font-size: 0.8em;\n}\n\n.show-loyalty-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.redeem-para-down-red {\n  color: red;\n  font-weight: 600;\n}\n\n.redeem-para-down-green {\n  color: green;\n  font-weight: 600;\n}\n\n.redeem-wrapper-btn-remove-red {\n  border: none;\n  width: 99%;\n  background-color: red;\n  color: #fff;\n  font-weight: 600;\n  margin-top: 15px;\n  border-radius: 5px;\n  padding: 8px;\n  text-transform: uppercase;\n}\n\n.all-product-wrapper-shortcuts-box {\n  border: 1px solid red;\n  height: 40px;\n  margin-top: 15px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.search-results-text {\n  padding: 10px 0px 10px 0px !important;\n}\n\n.searchLoader {\n  margin-top: 1rem;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n/* For Catefory Products view */\n.particularCategoryEachItemGridContainerCFS {\n  overflow-y: scroll !important;\n  display: grid;\n  align-content: flex-start;\n  flex: 1;\n  flex-wrap: wrap !important;\n  padding-top: 10px !important;\n  border-radius: 4px;\n}\n\n.particularCategoryEachItemCFS {\n  width: auto !important;\n  border-radius: 20px !important;\n  margin-bottom: 1vh !important;\n  border: 1.5px solid var(--surface-g1);\n  min-width: 10rem;\n  background-color: #fff;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.particularCategoryEachItemCFS.dark {\n  border: none !important;\n}\n\n.particularCategoryContainer::-webkit-scrollbar {\n  display: none;\n}\n\n.particularCategoryEachItemImgContainerCFS {\n  width: 100%;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  margin-bottom: 10px;\n  position: relative;\n}\n\n.particularCategoryEachItemImgCFS {\n  width: 100%;\n  height: 120px;\n  object-fit: cover;\n  border-radius: 5px !important;\n}\n\n.foodTypeIcon {\n  height: 14px;\n  width: 14px;\n  position: absolute;\n  left: 88%;\n  bottom: 82%;\n}\n\n.particularElementNameCFS {\n  font-size: 0.75rem;\n  text-transform: uppercase !important;\n  width: 100%;\n  font-weight: 700;\n  word-wrap: break-word;\n  white-space: normal;\n}\n/* Til Here */\n\n.navigate-wrapper-product-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 35px;\n  height: 35px;\n  cursor: pointer;\n}\n\n.dark .navigate-wrapper-product-box {\n  background-color: #353a50 !important;\n}\n\n.offer-details-highlight {\n  color: #0562fb !important;\n  font-size: 0.7rem;\n  font-weight: bold;\n}\n\n.light .offer-details-highlight {\n  color: white !important;\n}\n\n.dark .offer-details-highlight {\n  color: white !important;\n}\n\n.strike-off-mrp {\n  font-size: 1rem !important;\n}\n\n.sticky-box-mrp {\n  position: sticky;\n  top: 0;\n  background-color: #fff !important;\n  padding: 10px 10px 20px 10px !important;\n  text-align: center;\n  z-index: 99;\n}\n\n.dark .sticky-box-mrp {\n  position: sticky;\n  top: 0;\n  background-color: rgb(53, 58, 80) !important;\n  padding: 10px 10px 20px 10px !important;\n  text-align: center;\n}\n\n.text-mrp-heading {\n  text-transform: capitalize;\n  font-size: 18px !important;\n}\n\n.toggle-option-wrapper-modal {\n  padding: 2rem;\n  line-height: 2;\n  width: 100%;\n}\n\n.toggle-option-wrapper-modal:focus {\n  outline: none;\n}\n\n.configure-header-txt {\n  margin-left: 0.2rem;\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #5271ff;\n  line-height: 3;\n}\n\n.label-toggle-txt {\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  font-size: 1em;\n  font-weight: 500;\n  letter-spacing: 0.1rem;\n}\n\n.toggle-wrapper-btn-modal {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 1rem;\n}\n\n.save-toggle-wrapper-btn {\n  padding: 8px;\n  background-color: #0562fb;\n  color: #fff;\n  font-size: 0.8rem;\n  width: 120px;\n  border: none;\n  font-weight: 600;\n  border-radius: 5px;\n  cursor: pointer;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  margin: 2rem !important;\n}\n\n.save-toggle-wrapper-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.all-products-icon-cont {\n  position: absolute;\n  bottom: 0;\n  display: flex;\n  justify-content: flex-start;\n  gap: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
